import React, { useEffect } from "react";

const Backdrop = ({ activeBg, trackIndex, isPlaying }) => {
  useEffect(() => {
    document.documentElement.style.setProperty("--active-bg", activeBg);
  }, [trackIndex, activeBg]);

  return (
    <div className="p-2 text-xs">
      <a
        target="_blank"
        rel="noreferrer noopener"
        href="https://www.bensound.com/"
      >
        Royalty Free Music from Bensound
      </a>
    </div>
  );
};

export default Backdrop;
